import {Ambassador, ambassadorsWishes} from '@/resources/ambassadors';
import {NamedResourcesStatisticItem} from '@/resources/index';
import {BonusRedirectType} from '@/types';

export const CHARITY_ITEM_NAME = 'charity';

export const statisticItems: NamedResourcesStatisticItem[] = [
  {
    name: 'clothes',
    title: 'Алая Кепочка',
    imageLarge: {
      src: {
        png: 'static/ny25/hat-320-2024-10-28-09-05-28.png 320w, static/ny25/hat-760-2024-10-28-09-05-28.png 854w',
        avif: 'static/ny25/hat-320-2024-10-28-09-05-28.avif 320w, static/ny25/hat-760-2024-10-28-09-05-28.avif 854w',
        webp: 'static/ny25/hat-320-2024-10-28-09-05-28.webp 320w, static/ny25/hat-760-2024-10-28-09-05-28.webp 1387w',
      },
      alt: 'кепка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'кепка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.png 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.png 854w',
        avif: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.avif 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.avif 854w',
        webp: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.webp 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.webp 854w',
      },
      alt: 'кепка',
    },
    defaultStatistic: {
      title: '358 млрд ₽',
      description:
        'Столько клиенты Т‑Банка вложили в свой гардероб за год. На эту сумму можно было бы выбрать около 65 миллионов нарядов с стиле Зеленой Деревянной Змеи!',
    },
    extraDescription: 'Стильно и со вкусом!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Чтоб весь год вас сопровождал шик и блеск и вы сияли как звезды в безоблачную ночь!',
      buttonLink: null,
    },
  },
  {
    name: 'food',
    title: 'Крабовые спинки',
    imageLarge: {
      src: {
        png: 'static/ny25/crab-320-2024-10-28-08-43-47.png 320w, static/ny25/crab-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/crab-320-2024-10-28-08-43-47.avif 320w, static/ny25/crab-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/crab-320-2024-10-28-08-43-47.webp 320w, static/ny25/crab-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'краб',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.png 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.png 854w',
        avif: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.avif 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.avif 854w',
        webp: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.webp 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.webp 854w',
      },
      alt: 'краб',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.png 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.png 854w',
        avif: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.avif 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.avif 854w',
        webp: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.webp 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.webp 854w',
      },
      alt: 'краб',
    },
    defaultStatistic: {
      title: '790 млрд ₽',
      description:
        'Столько клиенты Т‑Банка оставили в ресторанах и кафе за год. На эти деньги можно было съесть около 859 тонн селедки под шубой. Вместе мы бы накрыли самый большой новогодний стол в истории!',
    },
    extraDescription: 'Каждый ваш чек — это маленькое гастрономическое приключение.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'От всей души желаю, чтоб новый год был вкусным и полным гастрономических открытий!',
      buttonLink: null,
    },
  },
  {
    name: 'pets',
    title: 'Дворняшки',
    imageLarge: {
      src: {
        png: 'static/ny25/dogs-320-2024-12-09-09-24-04.png 320w, static/ny25/dogs-760-2024-12-09-09-24-04.png 854w',
        avif: 'static/ny25/dogs-320-2024-12-09-09-24-04.avif 320w, static/ny25/dogs-760-2024-12-09-09-24-04.avif 854w',
        webp: 'static/ny25/dogs-320-2024-12-09-09-24-04.webp 320w, static/ny25/dogs-760-2024-12-09-09-24-04.webp 854w',
      },
      alt: 'собака',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/dogsSmall-320-2024-11-21-10-30-15.png 320w, static/ny25/dogsSmall-680-2024-11-21-10-30-15.png 854w',
        avif: 'static/ny25/dogsSmall-320-2024-11-21-10-30-15.avif 320w, static/ny25/dogsSmall-680-2024-11-21-10-30-15.avif 854w',
        webp: 'static/ny25/dogsSmall-320-2024-11-21-10-30-15.webp 320w, static/ny25/dogsSmall-680-2024-11-21-10-30-15.webp 854w',
      },
      alt: 'собака',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/dogsSmallOpened-320-2024-12-09-09-22-37.png 320w, static/ny25/dogsSmallOpened-680-2024-12-09-09-22-37.png 854w',
        avif: 'static/ny25/dogsSmallOpened-320-2024-12-09-09-22-37.avif 320w, static/ny25/dogsSmallOpened-680-2024-12-09-09-22-37.avif 854w',
        webp: 'static/ny25/dogsSmallOpened-320-2024-12-09-09-22-37.webp 320w, static/ny25/dogsSmallOpened-680-2024-12-09-09-22-37.webp 854w',
      },
      alt: 'собака',
    },
    defaultStatistic: {
      title: '33 млрд ₽',
      description:
        'На такую сумму клиенты Т‑Банка порадовали своих питомцев за год. На эти деньги можно было запрячь примерно 22 500 троек лошадей в сани Деда Мороза!',
    },
    extraDescription: 'В этой конфете спряталось много любви!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть ваши братья меньшие дарят вам тепло и верную дружбу каждый день!',
      buttonLink: null,
    },
  },
  {
    name: 'beauty',
    title: 'Скидочная помадка',
    imageLarge: {
      src: {
        png: 'static/ny25/lipstick-320-2024-12-09-09-37-29.png 320w, static/ny25/lipstick-760-2024-12-09-09-37-29.png 854w',
        avif: 'static/ny25/lipstick-320-2024-12-09-09-37-29.avif 320w, static/ny25/lipstick-760-2024-12-09-09-37-29.avif 854w',
        webp: 'static/ny25/lipstick-320-2024-12-09-09-37-29.webp 320w, static/ny25/lipstick-760-2024-12-09-09-37-29.webp 854w',
      },
      alt: 'помада',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/lipstickSmall-320-2024-11-21-10-30-15.png 320w, static/ny25/lipstickSmall-672-2024-11-21-10-30-15.png 854w',
        avif: 'static/ny25/lipstickSmall-320-2024-11-21-10-30-15.avif 320w, static/ny25/lipstickSmall-672-2024-11-21-10-30-15.avif 854w',
        webp: 'static/ny25/lipstickSmall-320-2024-11-21-10-30-15.webp 320w, static/ny25/lipstickSmall-672-2024-11-21-10-30-15.webp 854w',
      },
      alt: 'помада',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/lipstickSmallOpened-320-2024-12-09-09-35-41.png 320w, static/ny25/lipstickSmallOpened-680-2024-12-09-09-35-41.png 854w',
        avif: 'static/ny25/lipstickSmallOpened-320-2024-12-09-09-35-41.avif 320w, static/ny25/lipstickSmallOpened-680-2024-12-09-09-35-41.avif 854w',
        webp: 'static/ny25/lipstickSmallOpened-320-2024-12-09-09-35-41.webp 320w, static/ny25/lipstickSmallOpened-680-2024-12-09-09-35-41.webp 854w',
      },
      alt: 'помада',
    },
    defaultStatistic: {
      title: '150 млрд ₽',
      description:
        'На такую сумму клиенты Т‑Банка побаловали себя бьюти‑процедурами за год. За эти деньги Дед Мороз мог бы сделать себе груминг бороды и усов примерно 125 млн раз. Это самая красивая конфета в нашей коллекции!',
    },
    extraDescription: 'В этой конфете пряталось ваше прекрасное настроение!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Не забывайте свои корни, помните — они сами себя не покрасят!',
      buttonLink: null,
    },
  },
  {
    name: 'travel',
    title: 'Мармарис',
    imageLarge: {
      src: {
        png: 'static/ny25/plane-320-2024-10-28-08-59-28.png 320w, static/ny25/plane-760-2024-10-28-08-59-28.png 854w',
        avif: 'static/ny25/plane-320-2024-10-28-08-59-28.avif 320w, static/ny25/plane-760-2024-10-28-08-59-28.avif 854w',
        webp: 'static/ny25/plane-320-2024-10-28-08-59-28.webp 320w, static/ny25/plane-760-2024-10-28-08-59-28.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.png 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.png 1387w',
        avif: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.avif 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.avif 854w',
        webp: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.webp 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.webp 854w',
      },
      alt: 'самолет',
    },
    defaultStatistic: {
      title: ' 212 млрд ₽',
      description:
        'Такую сумму клиенты Т‑Банка потратили на путешествия в этом году. На эти деньги можно было около 8,4 млн раз слетать из Владивостока в Калининград, чтобы отметить Новый год в разных часовых поясах. Смакуем сладкое послевкусие путешествий!',
    },
    extraDescription: 'Эта конфета с привкусом классных впечатлений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть в новом году ваша копилочка пополнится новыми местами, где вы почувствуете запах приключений и вкус путешествий!',
      buttonLink: null,
    },
  },
  {
    name: 'transport',
    title: "С ветер'ком",
    imageLarge: {
      src: {
        png: 'static/ny25/car-320-2024-11-12-11-47-05.png 320w, static/ny25/car-760-2024-11-12-11-47-05.png 854w',
        avif: 'static/ny25/car-320-2024-11-12-11-47-05.avif 320w, static/ny25/car-760-2024-11-12-11-47-05.avif 854w',
        webp: 'static/ny25/car-320-2024-11-12-11-47-05.webp 320w, static/ny25/car-760-2024-11-12-11-47-05.webp 854w',
      },
      alt: 'машина',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/carSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/carSmall-681-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/carSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/carSmall-681-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/carSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/carSmall-681-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'машина',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/carSmallOpened-320-2024-12-09-09-09-57.png 320w, static/ny25/carSmallOpened-680-2024-12-09-09-09-57.png 854w',
        avif: 'static/ny25/carSmallOpened-320-2024-12-09-09-09-57.avif 320w, static/ny25/carSmallOpened-680-2024-12-09-09-09-57.avif 854w',
        webp: 'static/ny25/carSmallOpened-320-2024-12-09-09-09-57.webp 320w, static/ny25/carSmallOpened-680-2024-12-09-09-09-57.webp 854w',
      },
      alt: 'машина',
    },
    defaultStatistic: {
      title: '339 млрд ₽',
      description:
        'Такими были транспортные расходы всех клиентов Т‑Банка за год. На эту сумму можно было около 28 млн раз прокатиться в Суздале на санях, запряженных лошадьми!',
    },
    extraDescription: 'В обертке этой конфеты — карта ваших городских приключений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Academeg].title,
      avatar: ambassadorsWishes[Ambassador.Academeg].avatar,
      text: 'Какой бы маршрут вы ни выбрали, пусть он путь будет безопасным, комфортным и радостным!',
      buttonLink: null,
    },
  },
  {
    name: 'grocery',
    title: 'Бекончик',
    imageLarge: {
      src: {
        png: 'static/ny25/bacon-320-2024-11-12-11-47-05.png 320w, static/ny25/bacon-760-2024-11-12-11-47-05.png 854w',
        avif: 'static/ny25/bacon-320-2024-11-12-11-47-05.avif 320w, static/ny25/bacon-760-2024-11-12-11-47-05.avif 854w',
        webp: 'static/ny25/bacon-320-2024-11-12-11-47-05.webp 320w, static/ny25/bacon-760-2024-11-12-11-47-05.webp 854w',
      },
      alt: 'бекон',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/baconSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/baconSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/baconSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/baconSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/baconSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/baconSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'бекон',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/baconSmallOpened-320-2024-12-09-09-21-07.png 320w, static/ny25/baconSmallOpened-680-2024-12-09-09-21-07.png 854w',
        avif: 'static/ny25/baconSmallOpened-320-2024-12-09-09-21-07.avif 320w, static/ny25/baconSmallOpened-680-2024-12-09-09-21-07.avif 854w',
        webp: 'static/ny25/baconSmallOpened-320-2024-12-09-09-21-07.webp 320w, static/ny25/baconSmallOpened-680-2024-12-09-09-21-07.webp 854w',
      },
      alt: 'бекон',
    },
    defaultStatistic: {
      title: '2,1 трлн ₽',
      description:
        'Столько клиенты Т‑Банка потратили в супермаркетах за год. На эти деньги можно купить 9,2 млн тонн мандаринов с листочком!',
    },
    extraDescription: 'В эту конфету мы завернули все ваши вкусные находки!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Желаю, чтобы ваша продуктовая корзина была как чаша изобилия, где все — от картошки до арбуза — для вашего настроения!',
      buttonLink: null,
    },
  },
  {
    name: 'marketplace',
    title: 'Доставочка',
    imageLarge: {
      src: {
        png: 'static/ny25/squirrel-320-2024-12-09-09-14-27.png 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.png 854w',
        avif: 'static/ny25/squirrel-320-2024-12-09-09-14-27.avif 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.avif 854w',
        webp: 'static/ny25/squirrel-320-2024-12-09-09-14-27.webp 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.webp 854w',
      },
      alt: 'белка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'белка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.png 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.png 854w',
        avif: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.avif 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.avif 854w',
        webp: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.webp 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.webp 854w',
      },
      alt: 'белка',
    },
    defaultStatistic: {
      title: '480 млрд ₽',
      description:
        'Столько клиенты Т‑Банка потратили на маркетплейсах в этом году. На эти деньги можно было купить 1,18 млн километров гирлянды для украшения вашей улицы!',
    },
    extraDescription: 'Мы упаковали в эту конфету радость от каждой доставки!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Пусть приятные моменты тянутся долго, а доставка будет стремительна, да еще и с большой скидкой!',
      buttonLink: null,
    },
  },
  {
    name: 'home',
    title: 'Домашние тапки',
    imageLarge: {
      src: {
        png: 'static/ny25/ducks-320-2024-10-28-08-43-47.png 320w, static/ny25/ducks-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/ducks-320-2024-10-28-08-43-47.avif 320w, static/ny25/ducks-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/ducks-320-2024-10-28-08-43-47.webp 320w, static/ny25/ducks-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'утки',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.png 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.png 854w',
        avif: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.avif 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.avif 854w',
        webp: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.webp 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.webp 854w',
      },
      alt: 'утки',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.png 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.png 854w',
        avif: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.avif 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.avif 854w',
        webp: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.webp 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.webp 854w',
      },
      alt: 'утки',
    },
    defaultStatistic: {
      title: '458 млрд ₽',
      description:
        'На такую сумму клиенты Т‑Банка обустроили свои дома в этом году. Больше 16 млн живых елок можно было бы установить в ваших домах на эти деньги. В этой конфете — тепло тысяч уютных квартир!',
    },
    extraDescription: 'В этой конфете — радость от каждого обновления.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'Чтоб вы всегда были как за каменной стеной, а ваша уверенность пробивала все проблемы!',
      buttonLink: null,
    },
  },
  {
    name: 'zodiac',
    title: 'Астрологичные',
    imageLarge: {
      src: {
        png: 'static/ny25/sun-320-2024-12-03-11-12-36.png 320w, static/ny25/sun-760-2024-12-03-11-12-36.png 854w',
        avif: 'static/ny25/sun-320-2024-12-03-11-12-36.avif 320w, static/ny25/sun-760-2024-12-03-11-12-36.avif 854w',
        webp: 'static/ny25/sun-320-2024-12-03-11-12-36.webp 320w, static/ny25/sun-760-2024-12-03-11-12-36.webp 854w',
      },
      alt: 'солнце',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/sunSmall-320-2024-11-21-10-30-15.png 320w, static/ny25/sunSmall-670-2024-11-21-10-30-15.png 854w',
        avif: 'static/ny25/sunSmall-320-2024-11-21-10-30-15.avif 320w, static/ny25/sunSmall-670-2024-11-21-10-30-15.avif 854w',
        webp: 'static/ny25/sunSmall-320-2024-11-21-10-30-15.webp 320w, static/ny25/sunSmall-670-2024-11-21-10-30-15.webp 854w',
      },
      alt: 'солнце',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/sunSmallOpened-320-2024-12-09-09-33-01.png 320w, static/ny25/sunSmallOpened-680-2024-12-09-09-33-01.png 854w',
        avif: 'static/ny25/sunSmallOpened-320-2024-12-09-09-33-01.avif 320w, static/ny25/sunSmallOpened-680-2024-12-09-09-33-01.avif 854w',
        webp: 'static/ny25/sunSmallOpened-320-2024-12-09-09-33-01.webp 320w, static/ny25/sunSmallOpened-680-2024-12-09-09-33-01.webp 854w',
      },
      alt: 'солнце',
    },
    defaultStatistic: null,
    extraDescription: 'Эта конфета — с астрологическим характером!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть не звёзды влияют на ваши траты, а вы своими тратами на звёзды!',
      buttonLink: null,
    },
  },
  {
    name: 'minimalPurchase',
    title: 'Мини-леденец',
    imageLarge: {
      src: {
        png: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.png 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.png 854w',
        avif: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.avif 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.avif 854w',
        webp: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.webp 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.webp 854w',
      },
      alt: 'Мини-леденец',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.png 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.png 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.png 1387w',
        avif: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.avif 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.avif 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.avif 1387w',
        webp: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.webp 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.webp 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.webp 1387w',
      },
      alt: 'Мини-леденец',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.png 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.png 854w',
        avif: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.avif 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.avif 854w',
        webp: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.webp 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.webp 854w',
      },
      alt: 'Мини-леденец',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкая история о том, что размер конфеты не имеет значения!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Желаю тебе в новом году много маленьких радостей (в промежутках между большими). Кстати, в нашем мобильном приложении много поводов для радости!',
      buttonLink: {
        text: 'Порадовать открыткой',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/UsersContacts?utm_campaign=sp_ny25',
      },
    },
  },
  {
    name: 'maximumPurchaseDay',
    title: 'А-ну, догони!',
    imageLarge: {
      src: {
        png: 'static/ny25/maximumPurchaseDay-320-2024-12-09-12-32-04.png 320w, static/ny25/maximumPurchaseDay-760-2024-12-09-12-32-04.png 854w',
        avif: 'static/ny25/maximumPurchaseDay-320-2024-12-09-12-32-04.avif 320w, static/ny25/maximumPurchaseDay-760-2024-12-09-12-32-04.avif 854w',
        webp: 'static/ny25/maximumPurchaseDay-320-2024-12-09-12-32-04.webp 320w, static/ny25/maximumPurchaseDay-760-2024-12-09-12-32-04.webp 854w',
      },
      alt: 'А-ну, догони!',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/maximumPurchaseDaySmall-320-2024-12-09-12-26-01.png 320w, static/ny25/maximumPurchaseDaySmall-670-2024-12-09-12-26-01.png 854w',
        avif: 'static/ny25/maximumPurchaseDaySmall-320-2024-12-09-12-26-01.avif 320w, static/ny25/maximumPurchaseDaySmall-670-2024-12-09-12-26-01.avif 854w',
        webp: 'static/ny25/maximumPurchaseDaySmall-320-2024-12-09-12-26-01.webp 320w, static/ny25/maximumPurchaseDaySmall-670-2024-12-09-12-26-01.webp 854w',
      },
      alt: 'А-ну, догони!',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/maximumPurchaseDaySmallOpened-320-2024-12-09-12-25-00.png 320w, static/ny25/maximumPurchaseDaySmallOpened-680-2024-12-09-12-25-00.png 854w',
        avif: 'static/ny25/maximumPurchaseDaySmallOpened-320-2024-12-09-12-25-00.avif 320w, static/ny25/maximumPurchaseDaySmallOpened-680-2024-12-09-12-25-00.avif 854w',
        webp: 'static/ny25/maximumPurchaseDaySmallOpened-320-2024-12-09-12-25-00.webp 320w, static/ny25/maximumPurchaseDaySmallOpened-680-2024-12-09-12-25-00.webp 854w',
      },
      alt: 'А-ну, догони!',
    },
    defaultStatistic: null,
    extraDescription: 'Самая щедрая конфета в вашей коллекции!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Желаю шиковать от души и покупать с размахом!',
      buttonLink: null,
    },
  },
  {
    name: 'daysWithHugeSpends',
    title: 'Трата-сфера',
    imageLarge: {
      src: {
        png: 'static/ny25/rocket-320-2024-11-12-11-47-36.png 320w, static/ny25/rocket-760-2024-11-12-11-47-36.png 854w',
        avif: 'static/ny25/rocket-320-2024-11-12-11-47-36.avif 320w, static/ny25/rocket-760-2024-11-12-11-47-36.avif 854w',
        webp: 'static/ny25/rocket-320-2024-11-12-11-47-36.webp 320w, static/ny25/rocket-760-2024-11-12-11-47-36.webp 854w',
      },
      alt: 'ракета',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/rocketSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/rocketSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/rocketSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/rocketSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/rocketSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/rocketSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'ракета',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/rocketSmallOpened-320-2024-12-09-09-17-56.png 320w, static/ny25/rocketSmallOpened-680-2024-12-09-09-17-56.png 1387w',
        avif: 'static/ny25/rocketSmallOpened-320-2024-12-09-09-17-56.avif 320w, static/ny25/rocketSmallOpened-680-2024-12-09-09-17-56.avif 854w',
        webp: 'static/ny25/rocketSmallOpened-320-2024-12-09-09-17-56.webp 320w, static/ny25/rocketSmallOpened-680-2024-12-09-09-17-56.webp 854w',
      },
      alt: 'ракета',
    },
    defaultStatistic: null,
    extraDescription: 'Конфета с начинкой из щедрых моментов!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'Желаю в следующем году жить на широкую, как на курорте, где каждый день — праздник!',
      buttonLink: null,
    },
  },
  {
    name: 'daysWithHugeTotalBalance',
    title: 'Золотой сундучок',
    imageLarge: {
      src: {
        png: 'static/ny25/box-320-2024-12-03-11-12-36.png 320w, static/ny25/box-760-2024-12-03-11-12-36.png 854w',
        avif: 'static/ny25/box-320-2024-12-03-11-12-36.avif 320w, static/ny25/box-760-2024-12-03-11-12-36.avif 854w',
        webp: 'static/ny25/box-320-2024-12-03-11-12-36.webp 320w, static/ny25/box-760-2024-12-03-11-12-36.webp 854w',
      },
      alt: 'сундук',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/boxSmall-320-2024-11-21-10-30-15.png 320w, static/ny25/boxSmall-680-2024-11-21-10-30-15.png 854w',
        avif: 'static/ny25/boxSmall-320-2024-11-21-10-30-15.avif 320w, static/ny25/boxSmall-680-2024-11-21-10-30-15.avif 854w',
        webp: 'static/ny25/boxSmall-320-2024-11-21-10-30-15.webp 320w, static/ny25/boxSmall-680-2024-11-21-10-30-15.webp 854w',
      },
      alt: 'сундук',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/boxSmallOpened-320-2024-12-09-09-34-17.png 320w, static/ny25/boxSmallOpened-680-2024-12-09-09-34-17.png 854w',
        avif: 'static/ny25/boxSmallOpened-320-2024-12-09-09-34-17.avif 320w, static/ny25/boxSmallOpened-680-2024-12-09-09-34-17.avif 854w',
        webp: 'static/ny25/boxSmallOpened-320-2024-12-09-09-34-17.webp 320w, static/ny25/boxSmallOpened-680-2024-12-09-09-34-17.webp 854w',
      },
      alt: 'сундук',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкая история ваших сбережений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'Чтоб в следующем году ваше финансовое равновесие было таким же уверенным, как баланс тарелки с оливье за праздничным столом!',
      buttonLink: null,
    },
  },
  {
    name: 'nightPurchases',
    title: 'Сновидение',
    imageLarge: {
      src: {
        png: 'static/ny25/night-320-2024-11-28-12-38-07.png 320w, static/ny25/night-760-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/night-320-2024-11-28-12-38-07.avif 320w, static/ny25/night-760-2024-11-28-12-38-07.avif 854w',
        webp: 'static/ny25/night-320-2024-11-28-12-38-07.webp 320w, static/ny25/night-760-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'ночь',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/nightSmall-320-2024-11-28-12-38-07.png 320w, static/ny25/nightSmall-680-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/nightSmall-320-2024-11-28-12-38-07.avif 320w, static/ny25/nightSmall-680-2024-11-28-12-38-07.avif 854w',
        webp: 'static/ny25/nightSmall-320-2024-11-28-12-38-07.webp 320w, static/ny25/nightSmall-680-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'ночь',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/nightSmallOpened-320-2024-12-09-10-50-55.png 320w, static/ny25/nightSmallOpened-680-2024-12-09-10-50-55.png 1387w',
        avif: 'static/ny25/nightSmallOpened-320-2024-12-09-10-50-55.avif 320w, static/ny25/nightSmallOpened-680-2024-12-09-10-50-55.avif 854w',
        webp: 'static/ny25/nightSmallOpened-320-2024-12-09-10-50-55.webp 320w, static/ny25/nightSmallOpened-680-2024-12-09-10-50-55.webp 854w',
      },
      alt: 'ночь',
    },
    defaultStatistic: {
      title: '4%',
      description:
        'Именно такая доля покупок совершалась нашими клиентами ночью. Столько наших клиентов войдет в следующий год, так и не став жаворонками.',
    },
    extraDescription: 'Пока другие видели сны, вы находили лучшие предложения. Сладкая история ваших ночных открытий!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Желаю, чтобы в любое время дня и ночи — все было в ваших руках!',
      buttonLink: null,
    },
  },
  {
    name: 'onlineSpends',
    title: 'Мышка на сервере',
    imageLarge: {
      src: {
        png: 'static/ny25/mouse-320-2024-11-12-11-47-36.png 320w, static/ny25/mouse-760-2024-11-12-11-47-36.png 854w',
        avif: 'static/ny25/mouse-320-2024-11-12-11-47-36.avif 320w, static/ny25/mouse-760-2024-11-12-11-47-36.avif 854w',
        webp: 'static/ny25/mouse-320-2024-11-12-11-47-36.webp 320w, static/ny25/mouse-760-2024-11-12-11-47-36.webp 1387w',
      },
      alt: 'мышка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/mouseSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/mouseSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/mouseSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/mouseSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/mouseSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/mouseSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'мышка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/mouseSmallOpened-320-2024-12-09-09-19-08.png 320w, static/ny25/mouseSmallOpened-680-2024-12-09-09-19-08.png 854w',
        avif: 'static/ny25/mouseSmallOpened-320-2024-12-09-09-19-08.avif 320w, static/ny25/mouseSmallOpened-680-2024-12-09-09-19-08.avif 854w',
        webp: 'static/ny25/mouseSmallOpened-320-2024-12-09-09-19-08.webp 320w, static/ny25/mouseSmallOpened-680-2024-12-09-09-19-08.webp 854w',
      },
      alt: 'мышка',
    },
    defaultStatistic: {
      title: '18%',
      description:
        'Столько составили онлайн‑траты клиентов Т‑Банка в 2024 году. В этой конфете — удобство цифровых решений.',
    },
    extraDescription: 'В этой конфете — удобство цифровых решений.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть экранное время приносит пользу, а не только быстрый дофамин!',
      buttonLink: null,
    },
  },
  {
    name: 'assistant',
    title: 'Ассистентос',
    imageLarge: {
      src: {
        png: 'static/ny25/assistant-320-2024-12-09-11-33-11.png 320w, static/ny25/assistant-760-2024-12-09-11-33-11.png 854w',
        avif: 'static/ny25/assistant-320-2024-12-09-11-33-11.avif 320w, static/ny25/assistant-760-2024-12-09-11-33-11.avif 854w',
        webp: 'static/ny25/assistant-320-2024-12-09-11-33-11.webp 320w, static/ny25/assistant-760-2024-12-09-11-33-11.webp 854w',
      },
      alt: 'Ассистентос',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.png 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.png 854w',
        avif: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.avif 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.avif 854w',
        webp: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.webp 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.webp 854w',
      },
      alt: 'Ассистентос',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.png 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.png 854w',
        avif: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.avif 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.avif 854w',
        webp: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.webp 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.webp 854w',
      },
      alt: 'Ассистентос',
    },
    defaultStatistic: null,
    extraDescription: 'Каждый диалог помогал решать ваши задачи. Новогодняя карамель из ваших бесед!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Krut].title,
      avatar: ambassadorsWishes[Ambassador.Krut].avatar,
      text: 'Желаю в новом году оставаться КРУТым мастером коммуникаций!',
      buttonLink: {
        text: 'Перейти в сервис',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Chat?botid=oleg_kids_bot',
      },
    },
  },
  {
    name: CHARITY_ITEM_NAME,
    title: 'Мишка краснокнижный',
    imageLarge: {
      src: {
        png: 'static/ny25/bear-320-2024-12-09-10-28-43.png 320w, static/ny25/bear-760-2024-12-09-10-28-43.png 854w',
        avif: 'static/ny25/bear-320-2024-12-09-10-28-43.avif 320w, static/ny25/bear-760-2024-12-09-10-28-43.avif 854w',
        webp: 'static/ny25/bear-320-2024-12-09-10-28-43.webp 320w, static/ny25/bear-760-2024-12-09-10-28-43.webp 854w',
      },
      alt: 'медведь',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.png 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.png 854w',
        avif: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.avif 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.avif 854w',
        webp: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.webp 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.webp 854w',
      },
      alt: 'медведь',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.png 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.png 854w',
        avif: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.avif 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.avif 854w',
        webp: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.webp 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.webp 854w',
      },
      alt: 'медведь',
    },
    defaultStatistic: {
      title: '1,7 млрд ₽',
      description: 'Столько пожертвований сделали клиенты Т‑Банка за год. Вместе мы — сладкая фабрика заботы!',
    },
    extraDescription: 'Ваша помощь очень важна для тех, кто в ней нуждается.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Делайте добрые дела и пусть энергия добра возвращается к вам как кэшбэк в нашем банке!',
      buttonLink: {
        text: 'Пожертвовать',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Pay?ProviderGroup=Благотворительность',
      },
    },
  },
  {
    name: 'deposit',
    title: 'Миллиончик',
    imageLarge: {
      src: {
        png: 'static/ny25/million-320-2024-12-09-09-41-46.png 320w, static/ny25/million-760-2024-12-09-09-41-46.png 854w',
        avif: 'static/ny25/million-320-2024-12-09-09-41-46.avif 320w, static/ny25/million-760-2024-12-09-09-41-46.avif 854w',
        webp: 'static/ny25/million-320-2024-12-09-09-41-46.webp 320w, static/ny25/million-760-2024-12-09-09-41-46.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.png 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.png 854w',
        avif: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.avif 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.avif 854w',
        webp: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.webp 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.png 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.png 854w',
        avif: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.avif 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.avif 854w',
        webp: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.webp 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.webp 854w',
      },
      alt: 'лимон',
    },
    defaultStatistic: {
      title: '666 971',
      description:
        'Столько финансовых целей по накопительным счетам достигли клиенты Т‑Банка за год. Собрали огромную коробку сладких побед!',
    },
    extraDescription: 'Эта конфета — со вкусом правильных решений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Желаю, чтобы в следующем году ваши финансовые запасы не истощались, как запасы хлеба на утро понедельника!',
      buttonLink: null,
    },
  },
  {
    name: 'invest',
    title: 'Опцион',
    imageLarge: {
      src: {
        png: 'static/ny25/lemon-320-2024-11-12-11-47-36.png 320w, static/ny25/lemon-760-2024-11-12-11-47-36.png 854w',
        avif: 'static/ny25/lemon-320-2024-11-12-11-47-36.avif 320w, static/ny25/lemon-760-2024-11-12-11-47-36.avif 854w',
        webp: 'static/ny25/lemon-320-2024-11-12-11-47-36.webp 320w, static/ny25/lemon-760-2024-11-12-11-47-36.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/lemonSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/lemonSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/lemonSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/lemonSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/lemonSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/lemonSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/lemonSmallOpened-320-2024-12-09-09-11-55.png 320w, static/ny25/lemonSmallOpened-680-2024-12-09-09-11-55.png 854w',
        avif: 'static/ny25/lemonSmallOpened-320-2024-12-09-09-11-55.avif 320w, static/ny25/lemonSmallOpened-680-2024-12-09-09-11-55.avif 854w',
        webp: 'static/ny25/lemonSmallOpened-320-2024-12-09-09-11-55.webp 320w, static/ny25/lemonSmallOpened-680-2024-12-09-09-11-55.webp 854w',
      },
      alt: 'лимон',
    },
    defaultStatistic: null,
    extraDescription: 'Похоже, у вас отличное чутье на финансовые лакомства!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Чтоб в следующем году всё росло, как на дрожжах — балансы на счетах, настроение и котировки!',
      buttonLink: null,
    },
  },
  {
    name: 'mobile',
    title: 'Гигабайтоген',
    imageLarge: {
      src: {
        png: 'static/ny25/phone-320-2024-12-09-10-32-51.png 320w, static/ny25/phone-760-2024-12-09-10-32-51.png 854w',
        avif: 'static/ny25/phone-320-2024-12-09-10-32-51.avif 320w, static/ny25/phone-760-2024-12-09-10-32-51.avif 854w',
        webp: 'static/ny25/phone-320-2024-12-09-10-32-51.webp 320w, static/ny25/phone-760-2024-12-09-10-32-51.webp 854w',
      },
      alt: 'телефон',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/phoneSmall-320-2024-11-28-12-41-53.png 320w, static/ny25/phoneSmall-672-2024-11-28-12-41-53.png 854w',
        avif: 'static/ny25/phoneSmall-320-2024-11-28-12-41-53.avif 320w, static/ny25/phoneSmall-672-2024-11-28-12-41-53.avif 854w',
        webp: 'static/ny25/phoneSmall-320-2024-11-28-12-41-53.webp 320w, static/ny25/phoneSmall-672-2024-11-28-12-41-53.webp 854w',
      },
      alt: 'телефон',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/phoneSmallOpened-320-2024-12-09-10-30-49.png 320w, static/ny25/phoneSmallOpened-680-2024-12-09-10-30-49.png 854w',
        avif: 'static/ny25/phoneSmallOpened-320-2024-12-09-10-30-49.avif 320w, static/ny25/phoneSmallOpened-680-2024-12-09-10-30-49.avif 854w',
        webp: 'static/ny25/phoneSmallOpened-320-2024-12-09-10-30-49.webp 320w, static/ny25/phoneSmallOpened-680-2024-12-09-10-30-49.webp 854w',
      },
      alt: 'телефон',
    },
    defaultStatistic: {
      title: '7,2 млрд',
      description:
        'Столько минут длились все разговоры клиентов Т‑Мобайла. За это время можно было около 109 млрд раз прокричать кому‑то в ухо: «С Но‑вым го‑дом!».',
    },
    extraDescription: 'Целый год общения в праздничной обертке!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'В новом году всегда оставайтесь с близкими на связи!',
      buttonLink: null,
    },
  },
  {
    name: 'pro',
    title: 'Ореховое PROлине',
    imageLarge: {
      src: {
        png: 'static/ny25/nuts-320-2024-12-09-09-44-54.png 320w, static/ny25/nuts-380-2024-12-09-09-44-54.png 854w',
        avif: 'static/ny25/nuts-320-2024-12-09-09-44-54.avif 320w, static/ny25/nuts-380-2024-12-09-09-44-54.avif 854w',
        webp: 'static/ny25/nuts-320-2024-12-09-09-44-54.webp 320w, static/ny25/nuts-380-2024-12-09-09-44-54.webp 854w',
      },
      alt: 'орехи',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/nutsSmall-320-2024-11-26-12-43-39.png 320w, static/ny25/nutsSmall-680-2024-11-26-12-43-39.png 854w',
        avif: 'static/ny25/nutsSmall-320-2024-11-26-12-43-39.avif 320w, static/ny25/nutsSmall-680-2024-11-26-12-43-39.avif 854w',
        webp: 'static/ny25/nutsSmall-320-2024-11-26-12-43-39.webp 320w, static/ny25/nutsSmall-680-2024-11-26-12-43-39.webp 854w',
      },
      alt: 'орехи',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/nutsSmallOpened-320-2024-12-09-09-43-14.png 320w, static/ny25/nutsSmallOpened-680-2024-12-09-09-43-14.png 854w',
        avif: 'static/ny25/nutsSmallOpened-320-2024-12-09-09-43-14.avif 320w, static/ny25/nutsSmallOpened-680-2024-12-09-09-43-14.avif 854w',
        webp: 'static/ny25/nutsSmallOpened-320-2024-12-09-09-43-14.webp 320w, static/ny25/nutsSmallOpened-680-2024-12-09-09-43-14.webp 854w',
      },
      alt: 'орехи',
    },
    defaultStatistic: null,
    extraDescription: 'Самая привлекательная начинка этого года!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Подарите подписку близким, чтобы выгода никогда не покидала ни вас, ни ваших родных!',
      buttonLink: {
        text: 'Перейти в сервис',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Selfservice/TcrmPlayerFromChat?procId=tbundle_gift_mp&bundletype=pro&platformmb=ios',
      },
    },
  },
  {
    name: 'premium',
    title: 'КомФорт',
    imageLarge: {
      src: {
        png: 'static/ny25/premium-320-2024-12-09-11-58-10.png 320w, static/ny25/premium-760-2024-12-09-11-58-10.png 854w',
        avif: 'static/ny25/premium-320-2024-12-09-11-58-10.avif 320w, static/ny25/premium-760-2024-12-09-11-58-10.avif 854w',
        webp: 'static/ny25/premium-320-2024-12-09-11-58-10.webp 320w, static/ny25/premium-760-2024-12-09-11-58-10.webp 854w',
      },
      alt: 'премиум',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/premiumSmall-320-2024-12-10-10-28-40.png 320w, static/ny25/premiumSmall-680-2024-12-10-10-28-40.png 854w',
        avif: 'static/ny25/premiumSmall-320-2024-12-10-10-28-40.avif 320w, static/ny25/premiumSmall-680-2024-12-10-10-28-40.avif 854w',
        webp: 'static/ny25/premiumSmall-320-2024-12-10-10-28-40.webp 320w, static/ny25/premiumSmall-680-2024-12-10-10-28-40.webp 854w',
      },
      alt: 'премиум',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/premiumSmallOpened-320-2024-12-10-10-29-42.png 320w, static/ny25/premiumSmallOpened-680-2024-12-10-10-29-42.png 854w',
        avif: 'static/ny25/premiumSmallOpened-320-2024-12-10-10-29-42.avif 320w, static/ny25/premiumSmallOpened-680-2024-12-10-10-29-42.avif 854w',
        webp: 'static/ny25/premiumSmallOpened-320-2024-12-10-10-29-42.webp 320w, static/ny25/premiumSmallOpened-680-2024-12-10-10-29-42.webp 854w',
      },
      alt: 'премиум',
    },
    defaultStatistic: null,
    extraDescription: 'Это самая роскошная конфета на новогоднем столе!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Подарите Premium близким, чтобы выгода никогда не покидала ни вас, ни ваших родных!',
      buttonLink: {
        text: 'Перейти в сервис',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Selfservice/TcrmPlayerFromChat?procId=tbundle_gift_mp&bundletype=premium&platformmb=ios',
      },
    },
  },
  {
    name: 'self_employed',
    title: 'Работенка',
    imageLarge: {
      src: {
        png: 'static/ny25/coin-320-2024-11-28-12-38-08.png 320w, static/ny25/coin-760-2024-11-28-12-38-08.png 854w',
        avif: 'static/ny25/coin-320-2024-11-28-12-38-08.avif 320w, static/ny25/coin-760-2024-11-28-12-38-08.avif 854w',
        webp: 'static/ny25/coin-320-2024-11-28-12-38-08.webp 320w, static/ny25/coin-760-2024-11-28-12-38-08.webp 854w',
      },
      alt: 'монетка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/coinSmall-320-2024-11-28-12-38-06.png 320w, static/ny25/coinSmall-680-2024-11-28-12-38-06.png 854w',
        avif: 'static/ny25/coinSmall-320-2024-11-28-12-38-06.avif 320w, static/ny25/coinSmall-680-2024-11-28-12-38-06.avif 854w',
        webp: 'static/ny25/coinSmall-320-2024-11-28-12-38-06.webp 320w, static/ny25/coinSmall-680-2024-11-28-12-38-06.webp 854w',
      },
      alt: 'монетка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/coinSmallOpened-320-2024-12-09-09-47-11.png 320w, static/ny25/coinSmallOpened-680-2024-12-09-09-47-11.png 854w',
        avif: 'static/ny25/coinSmallOpened-320-2024-12-09-09-47-11.avif 320w, static/ny25/coinSmallOpened-680-2024-12-09-09-47-11.avif 854w',
        webp: 'static/ny25/coinSmallOpened-320-2024-12-09-09-47-11.webp 320w, static/ny25/coinSmallOpened-680-2024-12-09-09-47-11.webp 854w',
      },
      alt: 'монетка',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкий результат вашей независимости!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Чтоб с бизнесом было всё чётко! Пусть прибыль растёт, а успех идёт за вами, как хвост за котом!',
      buttonLink: null,
    },
  },
  {
    name: 'travel_city',
    title: 'Дубайский шоколад',
    imageLarge: {
      src: {
        png: 'static/ny25/dubai-320-2024-11-28-12-38-07.png 320w, static/ny25/dubai-760-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/dubai-320-2024-11-28-12-38-07.avif 320w, static/ny25/dubai-760-2024-11-28-12-38-07.avif 854w',
        webp: 'static/ny25/dubai-320-2024-11-28-12-38-07.webp 320w, static/ny25/dubai-760-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/dubaiSmall-320-2024-11-28-12-38-07.png 320w, static/ny25/dubaiSmall-680-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/dubaiSmall-320-2024-11-28-12-38-07.avif 320w, static/ny25/dubaiSmall-680-2024-11-28-12-38-07.avif 854w',
        webp: 'static/ny25/dubaiSmall-320-2024-11-28-12-38-07.webp 320w, static/ny25/dubaiSmall-680-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/dubaiSmallOpened-320-2024-12-09-10-40-50.png 320w, static/ny25/dubaiSmallOpened-680-2024-12-09-10-40-50.png 854w',
        avif: 'static/ny25/dubaiSmallOpened-320-2024-12-09-10-40-50.avif 320w, static/ny25/dubaiSmallOpened-680-2024-12-09-10-40-50.avif 854w',
        webp: 'static/ny25/dubaiSmallOpened-320-2024-12-09-10-40-50.webp 320w, static/ny25/dubaiSmallOpened-680-2024-12-09-10-40-50.webp 854w',
      },
      alt: 'самолет',
    },
    defaultStatistic: {
      title: '728',
      description: 'В столько мест слетали наши клиенты, купив билеты через сервис «Путешествия» в Городе в 2024 году.',
    },
    extraDescription: 'Эта конфета с привкусом классных впечатлений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть новый год принесет много ярких впечатлений и удивительных открытий!',
      buttonLink: null,
    },
  },
  {
    name: 'afisha_city',
    title: 'Леденцы занятные',
    imageLarge: {
      src: {
        png: 'static/ny25/hatPerson-320-2024-12-09-10-39-10.png 320w, static/ny25/hatPerson-760-2024-12-09-10-39-10.png 854w',
        avif: 'static/ny25/hatPerson-320-2024-12-09-10-39-10.avif 320w, static/ny25/hatPerson-760-2024-12-09-10-39-10.avif 854w',
        webp: 'static/ny25/hatPerson-320-2024-12-09-10-39-10.webp 320w, static/ny25/hatPerson-760-2024-12-09-10-39-10.webp 854w',
      },
      alt: 'леденцы',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/hatPersonSmall-320-2024-11-28-12-38-07.png 320w, static/ny25/hatPersonSmall-680-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/hatPersonSmall-320-2024-11-28-12-38-07.avif 320w, static/ny25/hatPersonSmall-680-2024-11-28-12-38-07.avif 1387w',
        webp: 'static/ny25/hatPersonSmall-320-2024-11-28-12-38-07.webp 320w, static/ny25/hatPersonSmall-680-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'леденцы',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/hatPersonSmallOpened-320-2024-12-09-10-38-07.png 320w, static/ny25/hatPersonSmallOpened-680-2024-12-09-10-38-07.png 1387w',
        avif: 'static/ny25/hatPersonSmallOpened-320-2024-12-09-10-38-07.avif 320w, static/ny25/hatPersonSmallOpened-680-2024-12-09-10-38-07.avif 854w',
        webp: 'static/ny25/hatPersonSmallOpened-320-2024-12-09-10-38-07.webp 320w, static/ny25/hatPersonSmallOpened-680-2024-12-09-10-38-07.webp 854w',
      },
      alt: 'леденцы',
    },
    defaultStatistic: {
      title: '722',
      description:
        'Столько мероприятий посетили клиенты Т‑Банка, купив билеты через сервис «Афиша» в Городе в 2024 году.',
    },
    extraDescription: 'Эта конфета — с начинкой из незабываемых впечатлений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Желаю вам украсить свой год самыми яркими мероприятиями!',
      buttonLink: null,
    },
  },
  {
    name: 'oil_city',
    title: 'Бачок',
    imageLarge: {
      src: {
        png: 'static/ny25/lobster-320-2024-10-28-08-43-47.png 320w, static/ny25/lobster-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/lobster-320-2024-10-28-08-43-47.avif 320w, static/ny25/lobster-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/lobster-320-2024-10-28-08-43-47.webp 320w, static/ny25/lobster-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'топливо',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'топливо',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.png 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.png 854w',
        avif: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.avif 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.avif 854w',
        webp: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.webp 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.webp 854w',
      },
      alt: 'топливо',
    },
    defaultStatistic: {
      title: '1 млрд',
      description:
        'На столько литров заправились все клиенты Т‑Банка в этом году через сервис «Топливо» в Городе. С таким количеством топлива Дед Мороз мог бы объехать всю страну примерно 171 568 раз, чтобы раздать подарки!',
    },
    extraDescription: 'Сладкая статистика ваших автопутешествий!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Academeg].title,
      avatar: ambassadorsWishes[Ambassador.Academeg].avatar,
      text: 'Пусть в новом году бензобак всегда будет полон, а дороги — легкими!',
      buttonLink: null,
    },
  },
  {
    name: 'grocery_city',
    title: 'Деликатес',
    imageLarge: {
      src: {
        png: 'static/ny25/dishes-320-2024-12-09-10-43-49.png 320w, static/ny25/dishes-760-2024-12-09-10-43-49.png 854w',
        avif: 'static/ny25/dishes-320-2024-12-09-10-43-49.avif 320w, static/ny25/dishes-760-2024-12-09-10-43-49.avif 854w',
        webp: 'static/ny25/dishes-320-2024-12-09-10-43-49.webp 320w, static/ny25/dishes-760-2024-12-09-10-43-49.webp 854w',
      },
      alt: 'деликатес',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.png 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.png 854w',
        avif: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.avif 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.avif 854w',
        webp: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.webp 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.webp 854w',
      },
      alt: 'деликатес',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.png 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.png 854w',
        avif: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.avif 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.avif 854w',
        webp: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.webp 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.webp 854w',
      },
      alt: 'деликатес',
    },
    defaultStatistic: null,
    extraDescription: 'Эта конфета с привкусом классных впечатлений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Пусть в новом году всегда будет тот, кому не жалко отдать большую половинку мандаринки!',
      buttonLink: null,
    },
  },
  {
    name: 'wordle',
    title: '5 букв',
    imageLarge: {
      src: {
        png: 'static/ny25/5letters-320-2024-12-09-11-03-24.png 320w, static/ny25/5letters-760-2024-12-09-11-03-24.png 854w',
        avif: 'static/ny25/5letters-320-2024-12-09-11-03-24.avif 320w, static/ny25/5letters-760-2024-12-09-11-03-24.avif 854w',
        webp: 'static/ny25/5letters-320-2024-12-09-11-03-24.webp 320w, static/ny25/5letters-760-2024-12-09-11-03-24.webp 854w',
      },
      alt: '5 букв',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/5lettersSmall-320-2024-12-09-11-02-18.png 320w, static/ny25/5lettersSmall-680-2024-12-09-11-02-18.png 854w',
        avif: 'static/ny25/5lettersSmall-320-2024-12-09-11-02-18.avif 320w, static/ny25/5lettersSmall-680-2024-12-09-11-02-18.avif 854w',
        webp: 'static/ny25/5lettersSmall-320-2024-12-09-11-02-18.webp 320w, static/ny25/5lettersSmall-680-2024-12-09-11-02-18.webp 854w',
      },
      alt: '5 букв',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/5lettersSmallOpened-320-2024-12-09-11-01-15.png 320w, static/ny25/5lettersSmallOpened-680-2024-12-09-11-01-15.png 854w',
        avif: 'static/ny25/5lettersSmallOpened-320-2024-12-09-11-01-15.avif 320w, static/ny25/5lettersSmallOpened-680-2024-12-09-11-01-15.avif 854w',
        webp: 'static/ny25/5lettersSmallOpened-320-2024-12-09-11-01-15.webp 320w, static/ny25/5lettersSmallOpened-680-2024-12-09-11-01-15.webp 854w',
      },
      alt: '5 букв',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкий результат ваших лингвистических подвигов!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Пусть идеи слов не заканчиваются, а удача всегда будет рядом!',
      buttonLink: {
        text: 'Играть',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Gamification/Projects?projectId=5bukv',
      },
    },
  },
  {
    name: 'sp_tbank',
    title: 'Конек-Игрунок',
    imageLarge: {
      src: {
        png: 'static/ny25/horse-320-2024-12-09-10-35-57.png 320w, static/ny25/horse-760-2024-12-09-10-35-57.png 854w',
        avif: 'static/ny25/horse-320-2024-12-09-10-35-57.avif 320w, static/ny25/horse-760-2024-12-09-10-35-57.avif 854w',
        webp: 'static/ny25/horse-320-2024-12-09-10-35-57.webp 320w, static/ny25/horse-760-2024-12-09-10-35-57.webp 854w',
      },
      alt: 'лошадь',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/horseSmall-320-2024-11-26-12-43-18.png 320w, static/ny25/horseSmall-680-2024-11-26-12-43-18.png 854w',
        avif: 'static/ny25/horseSmall-320-2024-11-26-12-43-18.avif 320w, static/ny25/horseSmall-680-2024-11-26-12-43-18.avif 854w',
        webp: 'static/ny25/horseSmall-320-2024-11-26-12-43-18.webp 320w, static/ny25/horseSmall-680-2024-11-26-12-43-18.webp 854w',
      },
      alt: 'лошадь',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/horseSmallOpened-320-2024-12-09-10-34-39.png 320w, static/ny25/horseSmallOpened-680-2024-12-09-10-34-39.png 854w',
        avif: 'static/ny25/horseSmallOpened-320-2024-12-09-10-34-39.avif 320w, static/ny25/horseSmallOpened-680-2024-12-09-10-34-39.avif 854w',
        webp: 'static/ny25/horseSmallOpened-320-2024-12-09-10-34-39.webp 320w, static/ny25/horseSmallOpened-680-2024-12-09-10-34-39.webp 854w',
      },
      alt: 'лошадь',
    },
    defaultStatistic: null,
    extraDescription: 'Каждый проект превратился в сладкое воспоминание!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Желаю побед и в жизни, и в играх!',
      buttonLink: null,
    },
  },
  {
    name: 'business_card',
    title: 'Капитан Голд',
    imageLarge: {
      src: {
        png: 'static/ny25/capitan-320-2024-11-28-09-03-10.png 320w, static/ny25/capitan-760-2024-11-28-09-03-10.png 854w',
        avif: 'static/ny25/capitan-320-2024-11-28-09-03-10.avif 320w, static/ny25/capitan-760-2024-11-28-09-03-10.avif 854w',
        webp: 'static/ny25/capitan-320-2024-11-28-09-03-10.webp 320w, static/ny25/capitan-760-2024-11-28-09-03-10.webp 854w',
      },
      alt: 'капитан',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/capitanSmall-320-2024-11-28-09-03-09.png 320w, static/ny25/capitanSmall-680-2024-11-28-09-03-09.png 854w',
        avif: 'static/ny25/capitanSmall-320-2024-11-28-09-03-09.avif 320w, static/ny25/capitanSmall-680-2024-11-28-09-03-09.avif 854w',
        webp: 'static/ny25/capitanSmall-320-2024-11-28-09-03-09.webp 320w, static/ny25/capitanSmall-680-2024-11-28-09-03-09.webp 1387w',
      },
      alt: 'капитан',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/capitanSmallOpened-320-2024-12-09-10-45-35.png 320w, static/ny25/capitanSmallOpened-680-2024-12-09-10-45-35.png 854w',
        avif: 'static/ny25/capitanSmallOpened-320-2024-12-09-10-45-35.avif 320w, static/ny25/capitanSmallOpened-680-2024-12-09-10-45-35.avif 854w',
        webp: 'static/ny25/capitanSmallOpened-320-2024-12-09-10-45-35.webp 320w, static/ny25/capitanSmallOpened-680-2024-12-09-10-45-35.webp 854w',
      },
      alt: 'капитан',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкий баланс работы и жизни!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Чтоб с бизнесом было всё чётко! Пусть прибыль растёт, а успех идёт за вами, как хвост за котом!',
      buttonLink: null,
    },
  },
  {
    name: 'mercury',
    title: 'Эзотеричные',
    imageLarge: {
      src: {
        png: 'static/ny25/cards-320-2024-12-09-09-38-55.png 320w, static/ny25/cards-760-2024-12-09-09-38-55.png 854w',
        avif: 'static/ny25/cards-320-2024-12-09-09-38-55.avif 320w, static/ny25/cards-760-2024-12-09-09-38-55.avif 854w',
        webp: 'static/ny25/cards-320-2024-12-09-09-38-55.webp 320w, static/ny25/cards-760-2024-12-09-09-38-55.webp 854w',
      },
      alt: 'карты',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/cardsSmall-320-2024-11-21-10-30-16.png 320w, static/ny25/cardsSmall-672-2024-11-21-10-30-16.png 854w',
        avif: 'static/ny25/cardsSmall-320-2024-11-21-10-30-16.avif 320w, static/ny25/cardsSmall-672-2024-11-21-10-30-16.avif 854w',
        webp: 'static/ny25/cardsSmall-320-2024-11-21-10-30-16.webp 320w, static/ny25/cardsSmall-672-2024-11-21-10-30-16.webp 854w',
      },
      alt: 'карты',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/cardsSmallOpened-320-2024-12-09-09-31-32.png 320w, static/ny25/cardsSmallOpened-680-2024-12-09-09-31-32.png 854w',
        avif: 'static/ny25/cardsSmallOpened-320-2024-12-09-09-31-32.avif 320w, static/ny25/cardsSmallOpened-680-2024-12-09-09-31-32.avif 854w',
        webp: 'static/ny25/cardsSmallOpened-320-2024-12-09-09-31-32.webp 320w, static/ny25/cardsSmallOpened-680-2024-12-09-09-31-32.webp 854w',
      },
      alt: 'карты',
    },
    defaultStatistic: null,
    extraDescription: 'Звезды подсказывают: вы не боитесь космических капризов!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Желаю, чтобы планеты реже ретроградили, а в жизни всегда была вселенская гармония!',
      buttonLink: null,
    },
  },
  {
    name: 'top3',
    title: 'Три-льяж',
    imageLarge: {
      src: {
        png: 'static/ny25/diamond-320-2024-11-28-12-41-54.png 320w, static/ny25/diamond-760-2024-11-28-12-41-54.png 854w',
        avif: 'static/ny25/diamond-320-2024-11-28-12-41-54.avif 320w, static/ny25/diamond-760-2024-11-28-12-41-54.avif 854w',
        webp: 'static/ny25/diamond-320-2024-11-28-12-41-54.webp 320w, static/ny25/diamond-760-2024-11-28-12-41-54.webp 854w',
      },
      alt: 'бриллиант',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/diamondSmall-320-2024-11-28-12-38-07.png 320w, static/ny25/diamondSmall-680-2024-11-28-12-38-07.png 854w',
        avif: 'static/ny25/diamondSmall-320-2024-11-28-12-38-07.avif 320w, static/ny25/diamondSmall-680-2024-11-28-12-38-07.avif 854w',
        webp: 'static/ny25/diamondSmall-320-2024-11-28-12-38-07.webp 320w, static/ny25/diamondSmall-680-2024-11-28-12-38-07.webp 854w',
      },
      alt: 'бриллиант',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/diamondSmallOpened-320-2024-12-09-10-49-04.png 320w, static/ny25/diamondSmallOpened-680-2024-12-09-10-49-04.png 854w',
        avif: 'static/ny25/diamondSmallOpened-320-2024-12-09-10-49-04.avif 320w, static/ny25/diamondSmallOpened-680-2024-12-09-10-49-04.avif 854w',
        webp: 'static/ny25/diamondSmallOpened-320-2024-12-09-10-49-04.webp 320w, static/ny25/diamondSmallOpened-680-2024-12-09-10-49-04.webp 854w',
      },
      alt: 'бриллиант',
    },
    defaultStatistic: null,
    extraDescription: 'Эта конфета — сладкое воплощение ваших крупных решений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Крупные траты — это крупные приобретения! Продолжай вкладывать в счастье и улыбки — прибыль не заставит себя ждать!',
      buttonLink: null,
    },
  },
  {
    name: 'region',
    title: 'Региональные',
    imageLarge: {
      src: {
        png: 'static/ny25/region-320-2024-12-19-13-15-29.png 320w, static/ny25/region-760-2024-12-19-13-15-29.png 854w',
        avif: 'static/ny25/region-320-2024-12-19-13-15-29.avif 320w, static/ny25/region-760-2024-12-19-13-15-29.avif 854w',
        webp: 'static/ny25/region-320-2024-12-19-13-15-29.webp 320w, static/ny25/region-760-2024-12-19-13-15-29.webp 854w',
      },
      alt: 'регион',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/regionSmall-320-2024-11-28-09-03-32.png 320w, static/ny25/regionSmall-680-2024-11-28-09-03-32.png 854w',
        avif: 'static/ny25/regionSmall-320-2024-11-28-09-03-32.avif 320w, static/ny25/regionSmall-680-2024-11-28-09-03-32.avif 854w',
        webp: 'static/ny25/regionSmall-320-2024-11-28-09-03-32.webp 320w, static/ny25/regionSmall-680-2024-11-28-09-03-32.webp 854w',
      },
      alt: 'регион',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/regionSmallOpened-320-2024-12-09-10-52-10.png 320w, static/ny25/regionSmallOpened-680-2024-12-09-10-52-10.png 854w',
        avif: 'static/ny25/regionSmallOpened-320-2024-12-09-10-52-10.avif 320w, static/ny25/regionSmallOpened-680-2024-12-09-10-52-10.avif 854w',
        webp: 'static/ny25/regionSmallOpened-320-2024-12-09-10-52-10.webp 320w, static/ny25/regionSmallOpened-680-2024-12-09-10-52-10.webp 854w',
      },
      alt: 'регион',
    },
    defaultStatistic: null,
    extraDescription: 'Получился персональный новогодний атлас со сладким послевкусием!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'Желаю вам в следующем году получить твердую пятерку по географии!',
      buttonLink: null,
    },
  },
  {
    name: 'sameСlients',
    title: 'По-Драже',
    imageLarge: {
      src: {
        png: 'static/ny25/dragee-320-2024-12-09-11-13-30.png 320w, static/ny25/dragee-760-2024-12-09-11-13-30.png 854w',
        avif: 'static/ny25/dragee-320-2024-12-09-11-13-30.avif 320w, static/ny25/dragee-760-2024-12-09-11-13-30.avif 854w',
        webp: 'static/ny25/dragee-320-2024-12-09-11-13-30.webp 320w, static/ny25/dragee-760-2024-12-09-11-13-30.webp 1387w',
      },
      alt: 'карты',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/drageeSmall-320-2024-12-09-11-12-13.png 320w, static/ny25/drageeSmall-681-2024-12-09-11-12-13.png 854w',
        avif: 'static/ny25/drageeSmall-320-2024-12-09-11-12-13.avif 320w, static/ny25/drageeSmall-681-2024-12-09-11-12-13.avif 854w',
        webp: 'static/ny25/drageeSmall-320-2024-12-09-11-12-13.webp 320w, static/ny25/drageeSmall-681-2024-12-09-11-12-13.webp 854w',
      },
      alt: 'карты',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/drageeSmallOpened-320-2024-12-09-11-10-56.png 320w, static/ny25/drageeSmallOpened-680-2024-12-09-11-10-56.png 854w',
        avif: 'static/ny25/drageeSmallOpened-320-2024-12-09-11-10-56.avif 320w, static/ny25/drageeSmallOpened-680-2024-12-09-11-10-56.avif 854w',
        webp: 'static/ny25/drageeSmallOpened-320-2024-12-09-11-10-56.webp 320w, static/ny25/drageeSmallOpened-680-2024-12-09-11-10-56.webp 854w',
      },
      alt: 'карты',
    },
    defaultStatistic: null,
    extraDescription: 'Конфета с начинкой из приятных совпадений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Желаю чаще находить родные души, которые всегда поддержат и поймут!',
      buttonLink: null,
    },
  },
  {
    name: 'hugeBalance',
    title: 'Получка',
    imageLarge: {
      src: {
        png: 'static/ny25/wallet-320-2024-12-09-13-15-52.png 320w, static/ny25/wallet-760-2024-12-09-13-15-52.png 854w',
        avif: 'static/ny25/wallet-320-2024-12-09-13-15-52.avif 320w, static/ny25/wallet-760-2024-12-09-13-15-52.avif 854w',
        webp: 'static/ny25/wallet-320-2024-12-09-13-15-52.webp 320w, static/ny25/wallet-760-2024-12-09-13-15-52.webp 854w',
      },
      alt: 'кошелек',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/walletSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/walletSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/walletSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/walletSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/walletSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/walletSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'кошелек',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/walletSmallOpened-320-2024-12-09-09-16-22.png 320w, static/ny25/walletSmallOpened-680-2024-12-09-09-16-22.png 854w',
        avif: 'static/ny25/walletSmallOpened-320-2024-12-09-09-16-22.avif 320w, static/ny25/walletSmallOpened-680-2024-12-09-09-16-22.avif 854w',
        webp: 'static/ny25/walletSmallOpened-320-2024-12-09-09-16-22.webp 320w, static/ny25/walletSmallOpened-680-2024-12-09-09-16-22.webp 854w',
      },
      alt: 'кошелек',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкий рекорд в новогодней обертке!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Желаю, чтобы ваш размах и масштаб всех впечатлил!',
      buttonLink: null,
    },
  },
  {
    name: 'secMB',
    title: 'Ирис В-приложении-завис',
    imageLarge: {
      src: {
        png: 'static/ny25/Iris-320-2024-12-09-11-08-39.png 320w, static/ny25/Iris-760-2024-12-09-11-08-39.png 854w',
        avif: 'static/ny25/Iris-320-2024-12-09-11-08-39.avif 320w, static/ny25/Iris-760-2024-12-09-11-08-39.avif 854w',
        webp: 'static/ny25/Iris-320-2024-12-09-11-08-39.webp 320w, static/ny25/Iris-760-2024-12-09-11-08-39.webp 854w',
      },
      alt: 'ирис',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.png 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.png 854w',
        avif: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.avif 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.avif 854w',
        webp: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.webp 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.webp 1387w',
      },
      alt: 'ирис',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.png 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.png 854w',
        avif: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.avif 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.avif 854w',
        webp: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.webp 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.webp 854w',
      },
      alt: 'ирис',
    },
    defaultStatistic: {
      title: '38 млрд',
      description:
        'Столько минут провели в мобильном приложении Т‑Банка все наши клиенты. За это время можно было 202 млн раз посмотреть «Иронию судьбы, или С легким паром!».',
    },
    extraDescription: 'Получилась самая яркая конфета года!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'С легким банкингом!',
      buttonLink: null,
    },
  },
  {
    name: 'hugeBenefit',
    title: 'Кибер cюрприз',
    imageLarge: {
      src: {
        png: 'static/ny25/surprise-320-2024-12-09-11-29-11.png 320w, static/ny25/surprise-760-2024-12-09-11-29-11.png 854w',
        avif: 'static/ny25/surprise-320-2024-12-09-11-29-11.avif 320w, static/ny25/surprise-760-2024-12-09-11-29-11.avif 854w',
        webp: 'static/ny25/surprise-320-2024-12-09-11-29-11.webp 320w, static/ny25/surprise-760-2024-12-09-11-29-11.webp 854w',
      },
      alt: 'Кибер cюрприз',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.png 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.png 854w',
        avif: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.avif 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.avif 854w',
        webp: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.webp 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.webp 854w',
      },
      alt: 'Кибер cюрприз',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.png 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.png 1387w',
        avif: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.avif 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.avif 854w',
        webp: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.webp 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.webp 1387w',
      },
      alt: 'Кибер cюрприз',
    },
    defaultStatistic: {
      title: '73 млрд ₽',
      description:
        'Столько кэшбэка мы выплатили клиентам в этом году. На эти деньги можно было сделать около 92,5 млн бутербродов с черной икрой.',
    },
    extraDescription: 'Ваши финансы работали с умом. Сладкая математика в новогодней обертке!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Желаю в новом году ловить выгоду, как рыбу в реке!',
      buttonLink: null,
    },
  },
  {
    name: '2025',
    title: '2025',
    imageLarge: {
      src: {
        png: 'static/ny25/2025-320-2024-12-09-11-24-50.png 320w, static/ny25/2025-760-2024-12-09-11-24-50.png 854w',
        avif: 'static/ny25/2025-320-2024-12-09-11-24-50.avif 320w, static/ny25/2025-760-2024-12-09-11-24-50.avif 854w',
        webp: 'static/ny25/2025-320-2024-12-09-11-24-50.webp 320w, static/ny25/2025-760-2024-12-09-11-24-50.webp 854w',
      },
      alt: '2025',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/2025Small-320-2024-12-09-11-23-49.png 320w, static/ny25/2025Small-681-2024-12-09-11-23-49.png 854w',
        avif: 'static/ny25/2025Small-320-2024-12-09-11-23-49.avif 320w, static/ny25/2025Small-681-2024-12-09-11-23-49.avif 854w',
        webp: 'static/ny25/2025Small-320-2024-12-09-11-23-49.webp 320w, static/ny25/2025Small-681-2024-12-09-11-23-49.webp 854w',
      },
      alt: '2025',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/2025SmallOpened-320-2024-12-09-11-22-38.png 320w, static/ny25/2025SmallOpened-680-2024-12-09-11-22-38.png 854w',
        avif: 'static/ny25/2025SmallOpened-320-2024-12-09-11-22-38.avif 320w, static/ny25/2025SmallOpened-680-2024-12-09-11-22-38.avif 854w',
        webp: 'static/ny25/2025SmallOpened-320-2024-12-09-11-22-38.webp 320w, static/ny25/2025SmallOpened-680-2024-12-09-11-22-38.webp 854w',
      },
      alt: '2025',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкая конфета с начинкой из приятных покупок!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Пусть каждая ваша трата приносит радость и удовлетворение, а ваши финансовые решения всегда ведут к успеху!',
      buttonLink: null,
    },
  },
  {
    name: 'comboSpends',
    title: 'Комбинашки',
    imageLarge: {
      src: {
        png: 'static/ny25/combo-320-2024-12-09-10-55-52.png 320w, static/ny25/combo-760-2024-12-09-10-55-52.png 854w',
        avif: 'static/ny25/combo-320-2024-12-09-10-55-52.avif 320w, static/ny25/combo-760-2024-12-09-10-55-52.avif 854w',
        webp: 'static/ny25/combo-320-2024-12-09-10-55-52.webp 320w, static/ny25/combo-760-2024-12-09-10-55-52.webp 854w',
      },
      alt: 'комбо',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/comboSmall-320-2024-12-09-10-57-34.png 320w, static/ny25/comboSmall-680-2024-12-09-10-57-34.png 854w',
        avif: 'static/ny25/comboSmall-320-2024-12-09-10-57-34.avif 320w, static/ny25/comboSmall-680-2024-12-09-10-57-34.avif 854w',
        webp: 'static/ny25/comboSmall-320-2024-12-09-10-57-34.webp 320w, static/ny25/comboSmall-680-2024-12-09-10-57-34.webp 854w',
      },
      alt: 'комбо',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/comboSmallOpened-320-2024-12-09-10-54-26.png 320w, static/ny25/comboSmallOpened-680-2024-12-09-10-54-26.png 854w',
        avif: 'static/ny25/comboSmallOpened-320-2024-12-09-10-54-26.avif 320w, static/ny25/comboSmallOpened-680-2024-12-09-10-54-26.avif 854w',
        webp: 'static/ny25/comboSmallOpened-320-2024-12-09-10-54-26.webp 320w, static/ny25/comboSmallOpened-680-2024-12-09-10-54-26.webp 854w',
      },
      alt: 'комбо',
    },
    defaultStatistic: null,
    extraDescription: 'Сладкая история вашего финансового характера!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Slutskiy].title,
      avatar: ambassadorsWishes[Ambassador.Slutskiy].avatar,
      text: 'Пусть в новом году жизнь радует вас идеальными комбо — из вкусов, встреч и моментов, которые хочется повторять снова и снова!',
      buttonLink: null,
    },
  },
  //убрала шоколадного скроллика
  {
    name: 'hugeBalanceJun',
    title: 'Скопитлз',
    imageLarge: {
      src: {
        png: 'static/ny25/hugeBalanceJun-320-2024-12-09-11-43-21.png 320w, static/ny25/hugeBalanceJun-760-2024-12-09-11-43-21.png 854w',
        avif: 'static/ny25/hugeBalanceJun-320-2024-12-09-11-43-21.avif 320w, static/ny25/hugeBalanceJun-760-2024-12-09-11-43-21.avif 854w',
        webp: 'static/ny25/hugeBalanceJun-320-2024-12-09-11-43-21.webp 320w, static/ny25/hugeBalanceJun-760-2024-12-09-11-43-21.webp 854w',
      },
      alt: 'Скопитлз',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/hugeBalanceJunSmall-320-2024-12-09-11-42-16.png 320w, static/ny25/hugeBalanceJunSmall-681-2024-12-09-11-42-16.png 854w',
        avif: 'static/ny25/hugeBalanceJunSmall-320-2024-12-09-11-42-16.avif 320w, static/ny25/hugeBalanceJunSmall-681-2024-12-09-11-42-16.avif 854w',
        webp: 'static/ny25/hugeBalanceJunSmall-320-2024-12-09-11-42-16.webp 320w, static/ny25/hugeBalanceJunSmall-681-2024-12-09-11-42-16.webp 854w',
      },
      alt: 'Скопитлз',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/hugeBalanceJunSmallOpened-320-2024-12-09-11-40-56.png 320w, static/ny25/hugeBalanceJunSmallOpened-680-2024-12-09-11-40-56.png 854w',
        avif: 'static/ny25/hugeBalanceJunSmallOpened-320-2024-12-09-11-40-56.avif 320w, static/ny25/hugeBalanceJunSmallOpened-680-2024-12-09-11-40-56.avif 854w',
        webp: 'static/ny25/hugeBalanceJunSmallOpened-320-2024-12-09-11-40-56.webp 320w, static/ny25/hugeBalanceJunSmallOpened-680-2024-12-09-11-40-56.webp 854w',
      },
      alt: 'Скопитлз',
    },
    defaultStatistic: null,
    extraDescription: 'Каждое пополнение — шаг к вашей цели. Мы собрали все ваши сбережения в праздничную обертку.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Krut].title,
      avatar: ambassadorsWishes[Ambassador.Krut].avatar,
      text: 'Крутыши, желаю вам, чтобы монеты в копилку попадали как шайбы в ворота!',
      buttonLink: null,
    },
  },
];
